import { OnInit, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { UiSettingForm } from '@components/ui-forms';
import { MessageTemplate, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { MessageTemplateService, ModalService, SettingService, } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, combineLatest, forkJoin, of as observableOf, } from 'rxjs';
import { finalize, switchMap, tap, } from 'rxjs/operators';
var EMPTY_SETTING_FORM = {
    formGroup: {},
};
var HostSettingsPageComponent = /** @class */ (function () {
    function HostSettingsPageComponent(settingService, _messageTemplateService, _modalService, _translateService, _snack, _appState) {
        this.settingService = settingService;
        this._messageTemplateService = _messageTemplateService;
        this._modalService = _modalService;
        this._translateService = _translateService;
        this._snack = _snack;
        this._appState = _appState;
        this.loading$ = new BehaviorSubject(true);
        this.settings = null;
        this.template = {};
        this.activeTab = 'General';
        this._forms = {};
    }
    Object.defineProperty(HostSettingsPageComponent.prototype, "general", {
        get: function () {
            return this._forms['general'] || EMPTY_SETTING_FORM;
        },
        set: function (ref) {
            if (!this._forms['general'] && !!ref) {
                this._forms['general'] = ref;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostSettingsPageComponent.prototype, "deployment", {
        get: function () {
            return this._forms['deployment'] || EMPTY_SETTING_FORM;
        },
        set: function (ref) {
            if (!this._forms['deployment'] && !!ref) {
                this._forms['deployment'] = ref;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostSettingsPageComponent.prototype, "mail", {
        get: function () {
            return this._forms['mail'] || EMPTY_SETTING_FORM;
        },
        set: function (ref) {
            if (!this._forms['mail'] && !!ref) {
                this._forms['mail'] = ref;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostSettingsPageComponent.prototype, "security", {
        get: function () {
            return this._forms['security'] || EMPTY_SETTING_FORM;
        },
        set: function (ref) {
            if (!this._forms['security'] && !!ref) {
                this._forms['security'] = ref;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostSettingsPageComponent.prototype, "scalability", {
        get: function () {
            return this._forms['scalability'] || EMPTY_SETTING_FORM;
        },
        set: function (ref) {
            if (!this._forms['scalability'] && !!ref) {
                this._forms['scalability'] = ref;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostSettingsPageComponent.prototype, "application", {
        get: function () {
            return this._forms['application'] || EMPTY_SETTING_FORM;
        },
        set: function (ref) {
            if (!this._forms['application'] && !!ref) {
                this._forms['application'] = ref;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostSettingsPageComponent.prototype, "customization", {
        get: function () {
            return this._forms['customization'] || EMPTY_SETTING_FORM;
        },
        set: function (ref) {
            if (!this._forms['customization'] && !!ref) {
                this._forms['customization'] = ref;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostSettingsPageComponent.prototype, "invalid", {
        get: function () {
            return this.general.formGroup.invalid ||
                this.deployment.formGroup.invalid ||
                this.mail.formGroup.invalid ||
                this.security.formGroup.invalid ||
                this.scalability.formGroup.invalid ||
                this.application.formGroup.invalid ||
                this.customization.formGroup.invalid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostSettingsPageComponent.prototype, "pristine", {
        get: function () {
            return this.general.formGroup.pristine &&
                this.deployment.formGroup.pristine &&
                this.mail.formGroup.pristine &&
                this.security.formGroup.pristine &&
                this.scalability.formGroup.pristine &&
                this.application.formGroup.pristine &&
                this.customization.formGroup.pristine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HostSettingsPageComponent.prototype, "hasUnsavedChanges", {
        get: function () {
            return !this.pristine;
        },
        enumerable: true,
        configurable: true
    });
    HostSettingsPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        forkJoin({
            settings: this.settingService.getServerSettings(),
            template: this._messageTemplateService.getTemplate(MessageTemplate.LoginLayout),
        }).pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function (_a) {
            var settings = _a.settings, template = _a.template;
            _this.settings = settings;
            _this.template = template;
        });
    };
    HostSettingsPageComponent.prototype.onSubmit = function () {
        this._checkEnableFolders();
    };
    HostSettingsPageComponent.prototype._checkEnableFolders = function () {
        var _this = this;
        var enableFolders = this.general.formGroup.get('isModernFolderSystemEnabled');
        var enableFoldersDirty = enableFolders.dirty;
        if (!enableFoldersDirty || !this.settings.general.isModernFolderSystemEnabled) {
            this._checkChanges();
        }
        else {
            this._modalService.onConfirm(null, function () { return _this._checkChanges(); }, function () {
                enableFolders.setValue(_this.settings.general.isModernFolderSystemEnabled = false);
                _this._checkChanges();
            }, this._translateService.instant('settings_general_enable_modern_sure'), true);
        }
    };
    HostSettingsPageComponent.prototype._checkChanges = function () {
        var _this = this;
        var overridable = ['general', 'deployment', 'mail', 'security'];
        var isOverridableChanged = overridable.some(function (setting) { return _this[setting].formGroup.dirty; });
        if (isOverridableChanged) {
            // confirm if anything other than the Application changed
            this._modalService.onConfirm(null, function () { return _this._onSubmit(); }, function () { }, this._translateService.instant('settings_save_warning_message'));
        }
        else {
            // save directly if only the application settings changed
            this._onSubmit();
        }
    };
    HostSettingsPageComponent.prototype._onSubmit = function () {
        var _this = this;
        if (this.pristine) {
            return;
        }
        this.loading$.next(true);
        var messageTemplateUpdate$ = this.customization.formGroup.dirty ?
            this._messageTemplateService
                .update(MessageTemplate.LoginLayout, this.template) :
            observableOf(null);
        combineLatest([
            this.settingService
                .updateSettingsBulk(this.settings, {
                'General': this.general.formGroup.dirty,
                'Deployment': this.deployment.formGroup.dirty,
                'Mail': this.mail.formGroup.dirty,
                'Security': this.security.formGroup.dirty,
                'Scalability': this.scalability.formGroup.dirty,
                'Application': this.application.formGroup.dirty,
            }),
            messageTemplateUpdate$,
        ])
            .pipe(switchMap(function () { return _this._appState.settings.fetch(); }), tap(function () {
            _this._snack.success(_this._translateService.instant('settings_save_success_message'));
            _this.settings = cloneDeep(_this.settings);
            _this.general.formGroup.reset(_this.general.formGroup.value);
            _this.deployment.formGroup.reset(_this.deployment.formGroup.getRawValue());
            _this.mail.formGroup.reset(_this.mail.formGroup.value);
            _this.security.formGroup.reset(_this.security.formGroup.value);
            _this.application.formGroup.reset(_this.application.formGroup.value);
            _this.scalability.formGroup.reset(_this.scalability.formGroup.getRawValue());
            _this.customization.formGroup.reset(_this.customization.formGroup.value);
        }), switchMap(function () { return _this.settingService.getServerSettings(); }), finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function (newSettings) { return _this.settings = newSettings; });
    };
    return HostSettingsPageComponent;
}());
export { HostSettingsPageComponent };
